<template>
    <div class="modal fade " tabindex="-1" role="dialog" id="modalNewFormation">
        <div class="modal-dialog">
            <div class="modal-content" v-if="newFormation">
                <div class="overlay ModalOverlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>

                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">×</span></button>
                    <h4 class="modal-title"> Ajouter une formation/un examen</h4>
                </div>

                <div class="modal-body">

                    <div class="form-group"
                         :class="{'has-error': errors.has('formation[titre]') }">
                        <label for="titre">Titre de la formation</label>
                        <input type="text" class="form-control" id="titre" name="formation[titre]"
                               v-validate="'required|max:200'"
                               placeholder="Nom de la formation/de l'examen" v-model="newFormation.titre">
                        <span v-show="errors.has('formation[titre]')" class="help-block">Le titre de la formation/de l'examen doit comporter moins de 200 caractères</span>
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('formation[date]') }">
                        <label>Date de la formation / de l'examen</label>
                        <div class="input-group date">
                            <div class="input-group-addon">
                                <i class="fa fa-calendar"></i>
                            </div>
                            <masked-input type="text"
                                          v-model="newFormation.date"
                                          v-validate="'required|date_format:DD/MM/YYYY'"
                                          :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                          :guide="true"
                                          :keepCharPositions="true"
                                          :showMask="true"
                                          name="formation[date]"
                                          class="form-control pull-right datepicker"
                                          id="datepicker2">
                            </masked-input>
                        </div>
                        <span v-show="errors.has('formation[date]')"
                              class="help-block">Date incorrecte</span>
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('formation[adresse]') }">
                        <label for="adresse">Adresse</label>
                        <textarea type="text" class="form-control" id="adresse" name="formation[adresse]"
                                  placeholder="Adresse"
                                  v-model="newFormation.adresse">{{newFormation.adresse}}</textarea>
                    </div>

                    <div class="form-group">
                        <label for="statut">Type de formation/examen</label>
                        <select id="statut" class="form-control" name="formation[type]" v-model="newFormation.idType">
                            <option value="19">Aucun/indéterminé</option>
                            <optgroup label="Grade">
                                <option
                                        v-for="type in getTypeByType('grade')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="Arbitre technique">
                                <option
                                        v-for="type in getTypeByType('arbitre_tech')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="Arbitre combat">
                                <option
                                        v-for="type in getTypeByType('arbitre_cbt')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="Divers">
                                <option
                                        v-for="type in getTypeByType('divers')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="ADEPS">
                                <option
                                        v-for="type in getTypeByType('adeps')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="ABFT">
                                <option
                                        v-for="type in getTypeByType('abft')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="Hapkido">
                                <option
                                        v-for="type in getTypeByType('hpk')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="Tangsoodo">
                                <option
                                        v-for="type in getTypeByType('tng')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                          <optgroup label="Haedong Kumdo">
                            <option
                              v-for="type in getTypeByType('hdkd')"
                              :value="type.id"
                            >{{type.type}}
                            </option>
                          </optgroup>

                            <optgroup label="ETU">
                                <option
                                        v-for="type in getTypeByType('ETU')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>
                            <optgroup label="WT (WTF)">
                                <option
                                        v-for="type in getTypeByType('WTF')"
                                        :value="type.id"
                                >{{type.type}}
                                </option>
                            </optgroup>

                        </select>
                    </div>

                    <div class="form-group">
                        <label for="statut">Formation/examen lié</label>
                        <select id="formationlie" class="form-control" name="formation[idFormationExamen]"
                                v-model="newFormation.idFormationExamen">
                            <option value="0">Aucun</option>
                            <option
                                    v-for="formation in getListeFormation"
                                    :value="formation.id"
                            >
                                {{formation.titre}}
                            </option>
                        </select>
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('formation[comments]') }">
                        <label for="adresse">Commentaires</label>
                        <textarea type="text" class="form-control" id="comments" name="formation[comments]"
                                  placeholder="Commentaires éventuels"
                                  v-model="newFormation.comments">{{newFormation.comments}}</textarea>
                    </div>

                    <div class="form-group">
                        <div class="checkbox">
                            <label for="cours_generaux">
                                <input id="cours_generaux" name="formation[cours_generaux]" type="checkbox"
                                       v-model="newFormation.cours_generaux">
                                Cours généraux ?
                            </label>
                        </div>
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-default pull-left" data-dismiss="modal">
                        Fermer
                    </button>
                    <button type="button"
                            class="btn btn-primary"
                            :disabled="errors.count()!=0 || this.newFormation.id_club==0 || this.disabledBtn || this.loadingInputs.length>0"
                            @click="addFormation()"
                    >
                        Ajouter une formation/un examen
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import {ErrorBag} from 'vee-validate';

    var $ = require('jquery');
    var _ = require('underscore')
    var moment = require('moment')

    export default {
        data() {
            return {
                loadingInputs: [],
                disabledBtn: false,
                newFormation: null,
                loading: false,
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
                getListeFormation: 'getListeFormation',
                getTypesFormation: 'getTypesFormation',
            }),
        },
        mounted: function () {
            var these = this
            this.newForm()
        },
        beforeRouteEnter(to, from, next) {
            next()
        },
        watch: {},
        components: {},
        methods: {
            ...mapActions({}),
            newForm() {
                this.newFormation = {
                    titre: "",
                    date: moment().format('DD/MM/YYYY'),
                    adresse:"",
                    idType:19,
                    idFormationExamen:0,
                    cours_generaux:0,
                    comments:"",
                }
            },
            addFormation: function () {
                this.disabledBtn = true;
                let self = this;
                this.$http.post(this.getRoute('Secretariat.formation.store'), this.constructForm()).then(function (response) {
                    self.$noty.success("La formation / l'examen a bien été créé")
                    self.disabledBtn = false
                    self.newForm()
                    self.$router.push({name: 'Formation', params: {formation_id: response.body.id}})
                    $('#modalNewFormation').modal('hide')
                }, (response) => {
                    self.$noty.error("Erreur dans la création de la nouvelle formation / du nouvel examen")
                    self.disabledBtn = false
                    $('#modalNewFormation').modal('hide')
                });
            },
            currentYear: function () {
                return moment().year();
            },
            console: function (event) {
                console.log(event);
            },
            constructForm: function () {
                return JSON.stringify({
                    "titre": this.newFormation.titre,
                    "date": this.formatDate(this.newFormation.date, "DD/MM/YYYY", "YYYY-MM-DD"),
                    "adresse": this.newFormation.adresse,
                    "idType": this.newFormation.idType,
                    "idFormationExamen": this.newFormation.idFormationExamen,
                    "cours_generaux": this.newFormation.cours_generaux,
                    "comments": this.newFormation.comments,
                })
            },
            getTypeByType: function (typeSearched) {
                let retour = [];
                this.getTypesFormation.forEach(function (item) {
                    if (item.meta == typeSearched)
                        retour.push(item);
                });
                return _.sortBy(retour, function (item) {
                    return item.order;
                });
            },
            formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
                if (value == null) return ''
                return moment(value, fmtIn).format(fmtOut)
            },
            isInputLoading: function (input) {
                return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
            },
            addToLoadingInputs: function (input) {
                this.loadingInputs.push(input)
            },
            removeFromLoadingInputs: function (input) {
                this.loadingInputs = _.without(this.loadingInputs, input)
            },
        },
        filters: {
            idFormat: function (value) {
                return new Intl.NumberFormat("de-DE").format(value)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Formation/ModalNewFormation.vue